import { SupportWrapper } from '../support/SupportStyles';
export const TermsWrapper = SupportWrapper;
